import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

// Blog posts live at /blog/<slug> (a separate Next.js app behind a Vercel
// rewrite). Links that drop the /blog prefix (e.g. from AI assistants or old
// shares) land here instead and showed a 404. For single-segment paths we
// check whether /blog/<slug> exists and, if so, send the visitor there.
const SLUG_PATH = /^\/[a-z0-9]+(?:-[a-z0-9]+)*\/?$/;

const NotFound = () => {
  const location = useLocation();
  const [checkingBlog, setCheckingBlog] = useState(() => SLUG_PATH.test(location.pathname));

  useEffect(() => {
    if (!SLUG_PATH.test(location.pathname)) {
      setCheckingBlog(false);
      console.error("404 Error: User attempted to access non-existent route:", location.pathname);
      return;
    }

    let cancelled = false;
    const slugPath = location.pathname.replace(/\/$/, "");
    const blogUrl = `/blog${slugPath}`;

    fetch(blogUrl, { method: "HEAD" })
      .then((res) => {
        if (cancelled) return;
        if (res.ok) {
          window.location.replace(`${blogUrl}${location.search}${location.hash}`);
        } else {
          setCheckingBlog(false);
          console.error("404 Error: User attempted to access non-existent route:", location.pathname);
        }
      })
      .catch(() => {
        if (!cancelled) setCheckingBlog(false);
      });

    return () => {
      cancelled = true;
    };
  }, [location.pathname, location.search, location.hash]);

  if (checkingBlog) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted">
        <p className="text-muted-foreground">Finding that page…</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
